/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

(function () {
  var selector = '[data-openai-lead-success]';

  function publish(marker) {
    if (!marker || marker.dataset.openaiLeadPublished === 'true') return;
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;

    var leadType = marker.getAttribute('data-openai-lead-success') || 'lead';
    var storageKey = ['market-spas-openai-lead', location.pathname, marker.id || leadType].join(':');
    try {
      if (sessionStorage.getItem(storageKey) === '1') return;
    } catch (error) {}

    marker.dataset.openaiLeadPublished = 'true';
    try {
      Shopify.analytics.publish('market_spas:lead_created', {
        lead_type: leadType,
        path: location.pathname
      });
      try { sessionStorage.setItem(storageKey, '1'); } catch (error) {}
    } catch (error) {
      marker.dataset.openaiLeadPublished = 'false';
    }
  }

  function scan(root) {
    if (root && root.matches && root.matches(selector)) publish(root);
    (root || document).querySelectorAll(selector).forEach(publish);
  }

  function init() {
    scan(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.documentElement, {childList: true, subtree: true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
